module.exports = __webpack_public_path__ + "static/media/check-refused.5f481abc.svg";